export const partnerSchools = [];
